import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar, MatSnackBarRef} from '@angular/material';
import {State} from '@progress/kendo-data-query';
import {DOCUMENT, TitleCasePipe} from '@angular/common';
import {SwitchComponent} from '@progress/kendo-angular-inputs';
import {AgmInfoWindow, AgmMap, AgmMarker} from '@agm/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {CalendarComponent} from "@progress/kendo-angular-dateinputs";
import {
  EventClickEvent,
  NavigateEvent,
  SchedulerComponent,
  SchedulerEvent,
  ViewChange
} from '@progress/kendo-angular-scheduler';
import * as moment from 'moment';
import {Observable, Subject, Subscription} from 'rxjs';
import {ApiService} from '../services/api';
import {MDLinkService} from '../services/mdlink/mdlink.service';
import {UserContext} from '../services/user-context';
import {AuthService} from '../services/auth';
import {ConfirmDialogComponent} from '../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {DataStateChangeEvent, GridDataResult, RowArgs, SelectionEvent} from '@progress/kendo-angular-grid';
import {AppointmentService} from '../services/appointment/appointment.service';
import {TranscriptionService} from '../services/api/transcription.service';

@Component({
  selector: 'app-telehealth',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'telehealth.template.html',
  styleUrls: [
    './telehealth.style.scss'
  ],
  animations: [
    trigger('ringerState', [
      state('inactive', style({
        opacity:0
      })),
      state('active',   style({
        opacity:1
      })),
      transition('inactive => active', animate('800ms ease-in')),
      transition('active => inactive', animate('0ms ease-out'))
    ])
  ]
})

export class TelehealthComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('onlineState', { static: true }) onlineState: SwitchComponent;
  @ViewChild('map', { static: true }) map: AgmMap;
  @ViewChild('infoWindow', { static: false }) infoWindow: AgmInfoWindow;
  @ViewChild('calendar', { static: false }) calendar: CalendarComponent;
  @ViewChild('scheduler', { static: false }) schedulerComponent: SchedulerComponent;

  public crumbs: any[] = [
    {label: 'Providers', link: '/providers'}
  ];

  lat = 35.268107;
  lng = -90.744821;
  zoom = 4;

  //providerId: string;
  //provider: any;
  appointments: any[];
  appointment: any;
  dailyAppointments: any[];
  markers: any[] = [];
  online = false;
  schedulerView:string;
  incomingSession:any;
  messageRef:any;
  offlineDialogOpened = false;
  ringing:any;
  ringer:string = "inactive";
  infoWindowIsOpen:boolean = false;
  now = new Date();
  schedulerDate: Date = new Date();
  upcomingSessions:SchedulerEvent[];
  eventSubject:Subject<SchedulerEvent> = new Subject<SchedulerEvent>();
  events: SchedulerEvent[] = [];
  schedulerSubject:Subject<SchedulerEvent[]> = new Subject<SchedulerEvent[]>();

  // Session grid support
  public sessionView: Observable<GridDataResult>;
  public sessionSubscription: Subscription;
  public sessionState: State = {
    skip: 0,
    take: 5
  };
  public selectedAppointment: RowArgs;
  private selectedNote: RowArgs;


  public mapStyles = [
    {elementType: 'geometry', stylers: [{color: '#aec3cb'}]},
    {elementType: 'labels.text.stroke', stylers: [{'visibility': 'off'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#888888'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#555555'}]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{'visibility': 'off'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#bbdefb'}]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#81d4fa'}]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#e3e8ee'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: 'transparent'}]
    }
  ];

  //private ngUnsubscribe: Subject<void> = new Subject<void>();
  //private mdlinkUnsubscribe: Subject<void> = new Subject<void>();
  private observer:any;
  private appointmentSubscription:Subscription;

  constructor(@Inject(DOCUMENT) private document: Document,
              private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService,
              private cd: ChangeDetectorRef,
              private appointmentService: AppointmentService,
              public userContext: UserContext,
              public dialog: MatDialog,
              private snackBar: MatSnackBar,
              private mdlinkService: MDLinkService,
              private api: ApiService) {
    //this.sessionView = sessionService;
    //this.sessionSubscription = sessionService.subscription;


    this.eventSubject.subscribe(e => {
      let filteredEvents = this.events.filter(ev => ev.id !== e.id);
      filteredEvents.push(e);
      this.events = filteredEvents;
      console.log("Publishing " + this.events.length + " events...");
      this.schedulerSubject.next(this.events);

      this.updateTimeLine();

      this.cd.detectChanges();
    });

    this.appointmentSubscription = this.appointmentService.subscribe(appointment => {
      this.appointment = appointment;
    })
  }


  public ngOnInit(): void {

    this.mdlinkService.connect();

    this.observer = this.mdlinkService.mdLinkSocket
      //.pipe(takeUntil(this.mdlinkUnsubscribe))
      .subscribe(message => {
        //console.log("Provider Dashboard received -> " + JSON.stringify(message,null,4));
        //let message = JSON.parse(socketMessage);
        if( message["status"] === "paging" ) {
          this.handlePage(message["consumer"]);
        } else if( message["recovered"] && message["session"]) {
          this.recoverSession(message["synchronicity"], message["session"]);
        } else if( message["status"] === "connecting" ) {
          this.handleIncomingSession(message["synchronicity"], message["session"]);
        } else if( message["status"] === "reset" ) {
          this.onlineState.checked = false;
          //console.log("Status reset.");
        } else if( message["status"] === "available" ) {
          this.onlineState.checked = true;
          //console.log("Status reset.");
        } else if( message["status"] === "aborted" ) {
          this.onlineState.checked = false;
          //console.log("Status aborted.");
        }
    });
  }

  public ngOnDestroy(): void {
    //this.ngUnsubscribe.next();
    //this.ngUnsubscribe.complete();
    //this.mdlinkUnsubscribe.next();
    //this.mdlinkUnsubscribe.complete();

    this.observer.unsubscribe();
    if( this.messageRef ) {
      this.messageRef.dismiss();
    }
    this.snackBar.dismiss();
  }

  public ngAfterViewInit(): void {
    this.updateAppointments();
  }

  public sessionStateChange(state: DataStateChangeEvent): void {
    this.sessionState = state;
  }

  public onSchedulerNavigation(event:NavigateEvent) {
    if( event.action.type === 'view-change' ) {
      this.schedulerView = (<ViewChange>event.action).view.name;
    }
  }

  public updateAppointments(): void {
    this.api.get<any>(`/appointment` ).subscribe( result => {
      //console.log("Filtering appointments with " + this.userContext.user.reference + " ");
      this.appointments = (result || []).filter(a => a.user_id && a.user_id.includes(this.userContext.user.reference) && (a.confirmed || a.invitation));
      //console.log("Adding appointments: " + JSON.stringify(this.appointments));
      (this.appointments || []).forEach( a => {
        this.eventSubject.next(<SchedulerEvent> {
          title: a.type || "Appointment",
          subject: a.subject,
          id: a.id,
          name: a.name,
          type: a.type,
          confirmed: a.confirmed,
          invitation: a.invitation,
          email: a.email,
          notes: a.notes,
          entity: a.entity,
          when: a.when,
          description: `${a.type || ""} Appointment`,
          start: moment(a.when).toDate(),
          end: moment(a.when).add(a.duration || 30, 'minutes').toDate()
        });
      });
      //this.updateAppointmentList();
    }, (error) => {
      this.snackBar.open(`Error getting appointments: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public doubleClickedEvent(event: EventClickEvent) {
    if ( !this.online ) {
      this.offlineDialogOpened = true
    } else {
      this.selectedAppointment = event.event;
      this.appointmentService.next(this.selectedAppointment.dataItem);
      console.log("Selected appointment: " + JSON.stringify(this.appointment));
      this.mdlinkService.startAppointment(this.selectedAppointment.dataItem.id);
      (function smoothscroll() {
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - (currentScroll / 8));
        }
      })();
    }
  }

  public updateTimeLine() {
    this.upcomingSessions = this.events.filter(a => a.start > this.now).sort( (a, b) => {return b.start.toISOString().localeCompare(a.start.toISOString())}).slice(0, 5);
  }

  public recoverSession(synchronicity:string, session:any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      data: {message:`Continue session with ${session.consumer.subject}?`, action:"Continue"}
    });

    dialogRef.afterClosed().subscribe(result => {

      if ( result ) {
        this.handleIncomingSession(synchronicity, session);
      } else {
        this.mdlinkService.reset(true);
      }
    });
  }

  public handleIncomingSession(synchronicity:string, session:any) {
    if( session ) {
      //if(this.messageRef) this.messageRef.dismiss();
      this.snackBar.dismiss();
      //console.log("Handling " + synchronicity + " session: " + JSON.stringify(session,null,4));
      if( synchronicity === 'asynchronous' ) {
        this.router.navigate(['sessions', session.id, 'deferred']);
      } else {
        this.router.navigate(['sessions', session.id, 'live']);
      }
    }
  }

  public handlePage(consumer:any) {
    this.ringer = "active";
    if( consumer ) {
      //console.log("Pushing marker.");
      if( consumer.location && consumer.location.latitude && consumer.location.longitude ) {
        this.lat = consumer.location.latitude;
        this.lng = consumer.location.longitude;
        this.zoom = 8;
        let name = consumer.synchronicity === 'asynchronous' ? `Deferred: ${consumer.subject}` : consumer.subject;
        this.markers.push({latitude:consumer.location.latitude, longitude:consumer.location.longitude, name:name});
        this.infoWindowIsOpen = true;
        if(this.infoWindow) {
          this.infoWindow.open()
        }
      }
    }
    this.ringing = new Audio("/assets/ring.wav"); // buffers automatically when created
    this.ringing.loop = true;
    this.ringing.volume = 0.2;
    this.ringing.play();
  }

  public reset(): void {
    this.api.patchTelehealth<any>(`/request`, {action:"reset"} ).subscribe( result => {
    }, (error) => {
      this.snackBar.open(`Error resetting: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public accept():void {

    this.ringer = "inactive";
    if( this.ringing ) {
      this.ringing.pause();
      this.ringing.currentTime = 0;
    }
    this.messageRef = this.snackBar.open(`Connecting...`, null)
    this.api.patchTelehealth<any>(`/request`, {action:"accept"} ).subscribe( result => {
    }, (error) => {
      this.snackBar.open(`Error accepting request: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public decline():void {
    this.ringer = "inactive";
    if( this.ringing ) {
      this.ringing.pause();
      this.ringing.currentTime = 0;
    }
    this.api.patchTelehealth<any>(`/request`, {action:"decline"} ).subscribe( result => {
      this.snackBar.open(`Request declined.`, null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error declining request: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public changeOnlineState($event):void {
    console.log("Chaning online state.");
    if(this.onlineState.checked) {
      console.log("Registering...");
      this.mdlinkService.register();
    } else {
      this.mdlinkService.reset(false);
      this.appointmentService.clear();
      this.selectedAppointment = null;
      if( this.ringing ) {
        this.ringing.pause();
        this.ringing.currentTime = 0;
      }
    }
  }


  public closeOfflineDialog() {
    this.offlineDialogOpened = false;
  }
}
